// 音效開關狀態
let isSoundEnabled = localStorage.getItem('isSoundEnabled') === 'true' || false;

// 快門音效
const shutterSound = new Audio('/sounds/shutter.mp3');

export const playButtonSound = (soundType: 'click' | 'delete' | 'reset' | 'shutter' = 'click') => {
  // 如果音效被禁用且不是快門聲音，直接返回
  if (!isSoundEnabled && soundType !== 'shutter') {
    return;
  }
  
  try {
    let soundPath = '/sounds/MouseClick-SoundEffect.mp3'; // 預設的點擊音效
    
    // 根據音效類型選擇不同的音效文件
    switch (soundType) {
      case 'delete':
        soundPath = '/sounds/MouseClick-SoundEffect.mp3'; // 暫時使用點擊音效，後續可替換
        break;
      case 'reset':
        soundPath = '/sounds/MouseClick-SoundEffect.mp3'; // 暫時使用點擊音效，後續可替換
        break;
      case 'shutter':
        // 直接使用已存在的快門音效
        shutterSound.currentTime = 0;
        shutterSound.play().catch((error: Error) => {
          console.error('播放快門音效失敗:', error);
        });
        return; // 直接返回，不需要創建新的 Audio 對象
      default:
        soundPath = '/sounds/MouseClick-SoundEffect.mp3';
    }
    
    // 創建並播放指定的音效
    const audio = new Audio(soundPath);
    audio.play().catch((error: Error) => {
      console.error(`播放 ${soundType} 音效失敗:`, error);
    });
  } catch (error) {
    console.error('播放音效時發生錯誤:', error);
  }
}; 